define('OutSystems/ClientRuntime/Validation',["require", "exports", "./WidgetNaming"], function (require, exports, WidgetNaming_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ValidationResult = exports.ValidationService = void 0;
    var RootKey = "";
    var ValidationService = (function () {
        function ValidationService(model, messagesProvider) {
            var _this = this;
            this.model = model;
            this.messagesProvider = messagesProvider;
            this.updatingValidations = false;
            this.disposed = false;
            if (!model.hasValidationWidgets) {
                return;
            }
            this.widgets = {};
            this.widgetChildren = {};
            this.oldModelWidgets = this.model.widgets;
            this.model.subscribeWrites(function () {
                if (!_this.updatingValidations && _this.oldModelWidgets !== _this.model.widgets) {
                    _this.recalculateAggregatorsState(RootKey);
                }
                _this.oldModelWidgets = _this.model.widgets;
            }, true);
        }
        ValidationService.prototype.getWidgetRecord = function (widgetId) {
            return this.model.widgets.get(widgetId);
        };
        ValidationService.prototype.updateWidgetValidationsProperties = function (widget, valid, validationMessage) {
            var previousValue = this.updatingValidations;
            this.updatingValidations = true;
            try {
                if (widget.isWebBlockInstance) {
                    var webBlockInstance = widget;
                    webBlockInstance.valid = valid;
                }
                else {
                    var modelWidget = this.getWidgetRecord(widget.getId());
                    if (modelWidget.validAttr !== valid) {
                        modelWidget.validAttr = valid;
                    }
                    if (validationMessage !== undefined && modelWidget.validationMessageAttr !== validationMessage) {
                        modelWidget.validationMessageAttr = validationMessage;
                    }
                }
            }
            finally {
                this.updatingValidations = previousValue;
            }
        };
        ValidationService.prototype.validateWidget = function (widgetId) {
            var result = true;
            for (var childId in this.widgetChildren[widgetId]) {
                if (this.validateWidget(childId) !== true) {
                    result = false;
                }
            }
            var widgetInstance = this.widgets[widgetId];
            if (widgetInstance) {
                var validateResult = null;
                if (widgetInstance.isValidationAggregator) {
                    validateResult = new ValidationResult(result);
                }
                else if (widgetInstance.validate) {
                    validateResult = widgetInstance.validate();
                }
                if (validateResult) {
                    this.updateWidgetValidationsProperties(widgetInstance, validateResult.valid, validateResult.validationMessage);
                    if (!validateResult.valid) {
                        result = false;
                    }
                }
            }
            return result;
        };
        ValidationService.prototype.recalculateAggregatorsState = function (widgetId) {
            var result = true;
            for (var childId in this.widgetChildren[widgetId]) {
                if (!this.recalculateAggregatorsState(childId)) {
                    result = false;
                }
            }
            var widgetInstance = this.widgets[widgetId];
            if (widgetInstance) {
                if (widgetInstance.isWebBlockInstance) {
                    return widgetInstance.valid;
                }
                else if (widgetInstance.isValidationAggregator) {
                    this.updateWidgetValidationsProperties(widgetInstance, result, undefined);
                }
                else {
                    return this.getWidgetRecord(widgetId).validAttr;
                }
            }
            return result;
        };
        ValidationService.prototype.register = function (widget) {
            if (!this.model.hasValidationWidgets) {
                return;
            }
            if (widget) {
                var widgetId = widget.getId();
                if (widgetId) {
                    this.widgets[widgetId] = widget;
                    var parentId = widget.validationParentId || RootKey;
                    var children = this.widgetChildren[parentId];
                    if (!children) {
                        children = {};
                        this.widgetChildren[parentId] = children;
                    }
                    children[widgetId] = 1;
                    if (!widget.isWebBlockInstance) {
                        var validationWidget = widget;
                        var widgetRecord = this.model.widgets.create(widgetId);
                        widgetRecord.generationNode = validationWidget.generationNode;
                        this.model.widgets.add(widgetRecord);
                    }
                }
            }
        };
        ValidationService.prototype.unregister = function (id) {
            if (!id || this.disposed || !this.model.hasValidationWidgets) {
                return;
            }
            var widgetInstance = this.widgets[id];
            var parentId = (widgetInstance ? widgetInstance.validationParentId : null) || RootKey;
            delete this.widgets[id];
            delete this.widgetChildren[parentId][id];
            if (widgetInstance) {
                this.model.widgets.remove(id);
            }
        };
        ValidationService.prototype.isRegistered = function (id) {
            return !!this.widgets && this.widgets[id] !== undefined;
        };
        ValidationService.prototype.validate = function (widgetId) {
            if (!this.model.hasValidationWidgets) {
                return true;
            }
            var result = this.validateWidget(widgetId || RootKey);
            if (widgetId) {
                result = this.recalculateAggregatorsState(RootKey);
            }
            this.model.flush();
            return result;
        };
        ValidationService.prototype.getMandatoryValueMessage = function () {
            return this.messagesProvider.getMandatoryValueMessage();
        };
        ValidationService.prototype.getInvalidValueMessage = function (type) {
            return this.messagesProvider.getInvalidValueMessage(type);
        };
        ValidationService.prototype.getNameById = function (id) {
            return WidgetNaming_1.WidgetIdService.nameFromId(id);
        };
        ValidationService.prototype.getWidgetChildren = function () {
            return this.widgetChildren;
        };
        ValidationService.prototype.dispose = function () {
            this.disposed = true;
        };
        return ValidationService;
    }());
    exports.ValidationService = ValidationService;
    var ValidationResult = (function () {
        function ValidationResult(valid, validationMessage) {
            this.valid = valid;
            this.validationMessage = validationMessage;
        }
        Object.defineProperty(ValidationResult.prototype, "valid", {
            get: function () {
                return this._valid;
            },
            set: function (value) {
                this._valid = value === undefined ? true : value;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ValidationResult.prototype, "validationMessage", {
            get: function () {
                return this._validationMessage;
            },
            set: function (value) {
                this._validationMessage = value || "";
            },
            enumerable: false,
            configurable: true
        });
        return ValidationResult;
    }());
    exports.ValidationResult = ValidationResult;
});
//# sourceMappingURL=Validation.js.map;
